export { default as Tags } from './tags.container';
